var _metadata, _path, _path2, _path3, _g, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("path", {
    d: "m9 42v-30h30v30z",
    fill: "none",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.22477 0 0 .22477 4.6698 4.9645)",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m86 151.84c33.325-19.753 53.75-54.959 53.75-94.197v-20.291l-53.75-19.888-53.75 19.888v20.291c0 39.238 20.425 74.444 53.75 94.197",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m86 155.88c-0.67187 0-1.4781-0.13438-2.0156-0.5375-34.938-20.694-55.766-57.244-55.766-97.691v-20.291c0-1.7469 1.075-3.225 2.6875-3.7625l53.75-19.888c0.94062-0.26875 1.8812-0.26875 2.8219 0l53.616 19.888c1.6125 0.5375 2.6875 2.15 2.6875 3.7625v20.291c0 40.447-20.828 76.997-55.766 97.691-0.5375 0.40312-1.3438 0.5375-2.0156 0.5375zm-49.719-115.7v17.469c0 36.819 18.544 70.009 49.719 89.494 31.175-19.35 49.719-52.675 49.719-89.494v-17.469l-49.719-18.409z",
    fill: "#841414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m86 136.52c-0.80625 0-1.7469-0.26875-2.4188-0.80625-21.366-15.722-34.938-38.969-38.431-65.172-0.26875-2.15 1.2094-4.1656 3.4938-4.5688 2.15-0.26875 4.1656 1.2094 4.5688 3.4938 3.0906 22.978 14.647 43.403 32.788 57.781 21.366-16.931 33.594-42.194 33.594-69.741v-6.1812l-33.594-12.362-36.281 13.438c-2.15 0.80625-4.4344-0.26875-5.2406-2.4188-0.80625-2.15 0.26875-4.4344 2.4188-5.2406l37.759-13.841c0.94062-0.26875 1.8812-0.26875 2.8219 0l37.625 13.975c1.6125 0.5375 2.6875 2.15 2.6875 3.7625v9.0031c0 31.175-14.244 59.662-39.238 78.072-0.80625 0.5375-1.7469 0.80625-2.5531 0.80625z",
    fill: "#e1c7c7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e1c7c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m86 34.669v97.825c23.784-17.603 37.625-44.881 37.625-74.847v-9.0031z",
    fill: "#e1c7c7"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.3988 0 0 .47856 26.429 24.465)",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "normal"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m30 41-4 4h-4l-4-4v-20h12v8l-2 2 2 2v2l-2 2 2 2z",
    fill: "#ffa000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m38 7.8008c-0.5-1.8008-2-3.1016-3.6992-3.6016-2.4023-0.5-6.1016-1.1992-10.301-1.1992s-7.8984 0.69922-10.301 1.1992c-1.6992 0.5-3.1992 1.8008-3.6992 3.6016-0.5 1.6992-1 4.0977-1 6.6992 0 2.6016 0.5 5 1 6.6992 0.5 1.8008 1.8984 3.1016 3.6992 3.5 2.4023 0.60156 6.1016 1.3008 10.301 1.3008s7.8984-0.69922 10.301-1.1992c1.8008-0.40234 3.1992-1.8008 3.6992-3.5 0.5-1.6992 1-4.1016 1-6.6992 0-2.7031-0.5-5.1016-1-6.8008zm-9 5.1992h-10c-1.1016 0-2-0.89844-2-2v-2c0-0.60156 3.1016-1 7-1 3.8984 0 7 0.39844 7 1v2c0 1.1016-0.89844 2-2 2z",
    fill: "#ffa000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m23 26h2v19h-2z",
    fill: "#d68600"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiKey);
export default __webpack_public_path__ + "static/media/apiKey.1ce0980fa4b8fd41ea41364cf7b77eae.svg";
export { ForwardRef as ReactComponent };